(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('advancePaymentApp')
        .constant('REQUEST_ADVANCE_CONST', {
            'RECEIPT_TYPE_KK':'4',
            'RECEIPT_TYPE_KK_NAME':'Khoản khác',
            'RECEIPT_SUBTYPE_KK':'1',
            'RECEIPT_SUBTYPE_KK_NAME':'Tạm thu khôi phục HĐ-PT1',
            'REGEX': "^[0-9a-zA-Z _ÀÁẠẢÃÂẤẦẪẬẨĂẮẰẲẴẶÈÉẸẺẼÊẾỀỂỄỆỌÕÒÓỎƠỚỜỞỠỢỐỒỔỖỘÔỈỊÌÍĨỲỴÝỶỸÙÚỤỦŨỨỪỬỮỰƯĐàáạảãâấầẩẫậăắằẳẵặèéẹẻẽêếềểễệìíĩỉịỳỵýỷỹọỏòóõơớờởỡợốồổỗộôùúũụủưứừửữựđ]+$",
            'STATUS':
                [{code:'GA_CREATE',name:'Đợi OM/GAD kiểm'},
                {code:'OM_APPROVAL',name:'Đợi CS duyệt'},
                {code:'CS_VERIFY',name:'Đợi ACC chi'},
                {code:'ACC_APPROVAL',name:'Đợi chuyển tiền'},
                {code:'CANCELED',name:'Huỷ'}],
            'FORMAT_EXPORT': 
                [{code:'excel',name:'EXCEL'},
                {code:'pdf',name:'PDF'}],
        })
        
})();